<template>
  <div class="right-table">
    <el-table
      border
      ref="table"
      :data="info.data"
      :row-key="getRowKeys"
      :row-style="{ color: '#51627D', fontWeight: 400 }"
      :header-cell-style="{
        background: '#DCE7FA',
        color: '#343C4A',
        fontWeight: 500,
      }"
      @selection-change="handleSelectionChanges"
    >
      <el-table-column
        type="selection"
        :selectable="selectInit"
        :reserve-selection="true"
        width="40"
      >
      </el-table-column>
      <el-table-column
        prop="bizName"
        label="资源名称"
        show-overflow-tooltip
        minWidth="200"
      ></el-table-column>
      <el-table-column
        v-if="activeTab == '1' || activeTab == '4'"
        prop="clientNames"
        label="展示终端"
        show-overflow-tooltip
        width="200"
      ></el-table-column>
      <el-table-column
        v-if="activeTab == '1'"
        prop="bizTypeName"
        label="类型"
        show-overflow-tooltip
        width="100"
      >
      </el-table-column>
      <el-table-column
        v-if="activeTab !== '5'"
        prop="onlineDate"
        label="上线时间"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        v-if="activeTab == '5'"
        prop="liveTime"
        label="直播时间"
      >
      <template slot-scope="scope">
        <span v-html="scope.row.liveTime"></span>
      </template>
    </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      @size-change="sizeChange"
      @current-change="pageChange"
      :current-page="info.currentPage"
      :page-size="info.size"
      :page-sizes="[10, 50, 100, 500, 1000]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="info.total"
      background
      hide-on-single-page
    />
  </div>
</template>
<script>
export default {
  props: {
    info: {
      type: Object,
      default: function() {
        return {};
      }
    },
    activeTab: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      getRowKeys(row) {
        return row.bizId;
      },
    }
  },
  created() {
  },
  methods: {
    handleSelectionChanges(rows) {
      this.$emit("HandleSelectionChanges", rows)
    },
    selectInit(row) {
      return !row.isCheck;
    },
    sizeChange(size) {
      this.$emit("SizeChange", size)
    },
    pageChange(page) {
      this.$emit("PageChange", page)
    }
  }
}
</script>
<style lang="scss" scoped>
.pagination {
  padding-top: 12px;
  float: right;
}
</style>